var map = {
	"./1.png": 985,
	"./10.png": 986,
	"./11.png": 987,
	"./12.png": 988,
	"./2.png": 989,
	"./3.png": 990,
	"./4.png": 991,
	"./5.png": 992,
	"./6.png": 993,
	"./7.png": 994,
	"./8.png": 995,
	"./9.png": 996
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 984;